import React from 'react';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogAction,
  AlertDialogCancel,
} from '@/components/ui/alert-dialog';
import { openExternalUrl } from '@/hooks/useExternalLink';
import type { VersionConfig } from '@/lib/appUpdateDecision';

interface UpdateAvailableDialogProps {
  open: boolean;
  required: boolean;
  config: VersionConfig | null;
  onDismiss: () => void;
}

export const UpdateAvailableDialog: React.FC<UpdateAvailableDialogProps> = ({ open, required, config, onDismiss }) => {
  if (!config) return null;
  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{config.title}</AlertDialogTitle>
          <AlertDialogDescription>
            {config.message}
            {required && ' Please update to continue using the app.'}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          {!required && <AlertDialogCancel onClick={onDismiss}>Later</AlertDialogCancel>}
          <AlertDialogAction
            onClick={(e) => { e.preventDefault(); openExternalUrl(config.store_url); }}
            className="w-full sm:w-auto"
          >
            Update
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
